import { GoalBasedFinancialPlanDateId } from "@fartherfinance/frontend/api/FinancialPlans/ids";
import { GoalBasedFinancialPlanRetirementHorizonResponse } from "@fartherfinance/frontend/api/FinancialPlans/retirementHorizon/types";
import { GoalBasedPlanDateRequest } from "@fartherfinance/frontend/api/FinancialPlans/types";
import { ClientId } from "@fartherfinance/frontend/api/Types";

import {
  CalendarYearEndField,
  CalendarYearStartField,
  EndsField,
  RepeatsField,
  SpousesAgeEndField,
  SpousesAgeStartField,
  StartsField,
  TargetDateField,
  YourAgeEndField,
  YourAgeStartField,
} from "../constants";
import { RepeatDropdownFormFieldTypes } from "../Types";

import { generatePlanDateFromFormValues } from "./generatePlanDateFromFormValues";

interface Params {
  clientId: ClientId;
  endPlanDateId?: GoalBasedFinancialPlanDateId;
  retirementHorizons: GoalBasedFinancialPlanRetirementHorizonResponse[];
  startPlanDateId?: GoalBasedFinancialPlanDateId;
  form: RepeatDropdownFormFieldTypes;
}

export const generateStartAndEndPlanDatesFromForm = ({
  clientId,
  endPlanDateId,
  retirementHorizons,
  startPlanDateId,
  form,
}: Params): [GoalBasedPlanDateRequest, GoalBasedPlanDateRequest | null] => {
  const repeats = form[RepeatsField].value;

  const startDate = generatePlanDateFromFormValues({
    clientId,
    planDateId: startPlanDateId,
    targetDate: form[TargetDateField],
    value: form[StartsField].value,
    calendarYear: form[CalendarYearStartField],
    yourAge: form[YourAgeStartField],
    spousesAge: form[SpousesAgeStartField],
    retirementHorizons,
    repeats,
  });

  if (repeats === "None") {
    return [startDate, null];
  }

  const endDate = generatePlanDateFromFormValues({
    clientId,
    planDateId: endPlanDateId,
    targetDate: form[TargetDateField],
    value: form[EndsField].value,
    calendarYear: form[CalendarYearEndField],
    yourAge: form[YourAgeEndField],
    spousesAge: form[SpousesAgeEndField],
    retirementHorizons,
    repeats,
  });

  return [startDate, endDate];
};
